import { Component, Input } from '@angular/core';

import { InAppBrowser, InAppBrowserObject } from "@ionic-native/in-app-browser";

/**
 * Generated class for the PhcArticleComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'phc-article',
  templateUrl: 'phc-article.html'
})
export class PhcArticleComponent {

  @Input() article;
  browser: InAppBrowserObject;

  constructor(private iab: InAppBrowser) {

  }

  handleArticleClick(evt){
    if(evt.target.tagName === 'A'){
      evt.preventDefault();
      this.browser = this.iab.create(evt.target.href, '_blank');
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/phc-article/phc-article.ts